
// Mock up of going back to forms - REMOVE FROM PROD
$(document).ready(function() {

  $('.bttn-prev').on('click', function() {
    window.history.go(-1);
  });

  $('.card-file .edit-button').on('click', function() {
    window.location = window.location.href.replace('my-', '');
  });

  if ($('#leaveSetup').length) {
    $('.form-heading-nav a, a.bttn.bttn-back')
      .attr('data-toggle', 'modal')
      .attr('data-target', '#leaveSetup')
  }

  if ($('admin-modal-submit-button').length) {
    $('.form-heading-nav a, a.bttn.bttn-back')
      .attr('data-toggle', 'modal')
      .attr('data-target', '#leaveSetup')
  }

});
